export default function setupPtBrTranslations(e) {
    const a = (e["pt-br"] = e["pt-br"] || {});
    a.dictionary = Object.assign(a.dictionary || {},
        {
            "%0 of %1": "%0 de %1",
            Aquamarine: "Água-marinha",
            Black: "Preto",
            "Block quote": "Bloco de citação",
            Blue: "Azul",
            Bold: "Negrito",
            "Break text": "",
            "Bulleted List": "Lista com marcadores",
            Cancel: "Cancelar",
            "Cannot upload file:": "Não foi possível enviar o arquivo:",
            "Centered image": "Imagem centralizada",
            "Change image text alternative": "Alterar texto alternativo da imagem",
            "Choose heading": "Escolha o estilo",
            Column: "Coluna",
            "Could not insert image at the current position.": "Não foi possível inserir a imagem na posição atual",
            "Could not obtain resized image URL.": "Não foi possível obter o endereço da imagem redimensionada",
            "Decrease indent": "Diminuir indentação",
            "Delete column": "Excluir coluna",
            "Delete row": "Excluir linha",
            "Dim grey": "Cinza escuro",
            Downloadable: "Pode ser baixado",
            "Dropdown toolbar": "Barra de Ferramentas da Lista Suspensa",
            "Edit block": "Editor de bloco",
            "Edit link": "Editar link",
            "Editor toolbar": "Ferramentas do Editor",
            "Enter image caption": "Inserir legenda da imagem",
            "Full size image": "Imagem completa",
            Green: "Verde",
            Grey: "Cinza",
            "Header column": "Coluna de cabeçalho",
            "Header row": "Linha de cabeçalho",
            Heading: "Titulo",
            "Heading 1": "Título 1",
            "Heading 2": "Título 2",
            "Heading 3": "Título 3",
            "Heading 4": "Título 4",
            "Heading 5": "Título 5",
            "Heading 6": "Título 6",
            "Image toolbar": "Ferramentas de Imagem",
            "image widget": "Ferramenta de imagem",
            "In line": "",
            "Increase indent": "Aumentar indentação",
            "Insert column left": "Inserir coluna à esquerda",
            "Insert column right": "Inserir coluna à direita",
            "Insert image": "Inserir imagem",
            "Insert image or file": "Inserir imagem ou arquivo",
            "Insert media": "Inserir mídia",
            "Insert paragraph after block": "Inserir parágrafo após o bloco",
            "Insert paragraph before block": "Inserir parágrafo antes do bloco",
            "Insert row above": "Inserir linha acima",
            "Insert row below": "Inserir linha abaixo",
            "Insert table": "Inserir tabela",
            "Inserting image failed": "Falha ao inserir imagem",
            Italic: "Itálico",
            "Left aligned image": "Imagem alinhada à esquerda",
            "Light blue": "Azul claro",
            "Light green": "Verde claro",
            "Light grey": "Cinza claro",
            Link: "Link",
            "Link URL": "URL",
            "Media URL": "URL da mídia",
            "media widget": "Ferramenta de mídia",
            "Merge cell down": "Mesclar abaixo",
            "Merge cell left": "Mesclar à esquerda",
            "Merge cell right": "Mesclar à direita",
            "Merge cell up": "Mesclar acima",
            "Merge cells": "Mesclar células",
            Next: "Próximo",
            "Numbered List": "Lista numerada",
            "Open in a new tab": "Abrir em nova aba",
            "Open link in new tab": "Abrir link em nova aba",
            Orange: "Laranja",
            Paragraph: "Parágrafo",
            "Paste the media URL in the input.": "Cole o endereço da mídia no campo.",
            Previous: "Anterior",
            Purple: "Púrpura",
            Red: "Vermelho",
            Redo: "Refazer",
            "Rich Text Editor": "Editor de Formatação",
            "Rich Text Editor,% 0": "Editor de Formatação,% 0",
            "Right aligned image": "Imagem alinhada à direita",
            Row: "Linha",
            Save: "Salvar",
            "Select all": "Selecionar tudo",
            "Select column": "Selecionar coluna",
            "Select row": "Selecionar linha",
            "Selecting resized image failed": "Seleção da imagem redimensionada falhou",
            "Show more items": "Exibir mais itens",
            "Side image": "Imagem lateral",
            "Split cell horizontally": "Dividir horizontalmente",
            "Split cell vertically": "Dividir verticalmente",
            "Table toolbar": "Ferramentas de Tabela",
            "Text alternative": "Texto alternativo",
            "The URL must not be empty.": "A URL não pode ficar em branco.",
            "This link has no URL": "Este link não possui uma URL",
            "This media URL is not supported.": "A URL desta mídia não é suportada.",
            "Tip: Paste the URL into the content to embed faster.": "Cole o endereço dentro do conteúdo para embutir mais rapidamente.",
            "Toggle caption off": "",
            "Toggle caption on": "",
            Turquoise: "Turquesa",
            Undo: "Desfazer",
            Unlink: "Remover link",
            "Upload failed": "Falha ao subir arquivo",
            "Upload in progress": "Enviando dados",
            White: "Branco",
            "Widget toolbar": "Ferramentas de Widgets",
            "Wrap text": "",
            Yellow: "Amarelo",
            'Underline': 'Sublinhado',
            'Font Background Color': 'Cor de fundo',
            'Font Color': 'Cor de texto',
            'Remove color': 'Remover cor',
            'Subscript': 'Subscrito',
            'Superscript': 'Sobrescrito',
            'Strikethrough': 'Riscado',
            'Text alignment': 'Alinhamento de texto',
            'Align left': 'Alinhamento à esquerda',
            'Align right': 'Alinhamento à direita',
            'Align center': 'Alinhamento ao centro',
            'Justify': 'Justificado',
            'Decimal with leading zero': 'Decimal começando com zero',
            'Lower-roman': 'Romano minúsculo',
            'Upper-roman': 'Romano maiúsculo',
            'Lower-latin': 'Letras minúsculas',
            'Upper-latin': 'Letras maiúsculas',
            'Disc': 'Disco',
            'Circle': 'Círculo',
            'Square': 'Quadrado',
            'Remove Format': 'Remover formatação'
        });
    a.getPluralForm = function (e) { return e > 1 };
}
(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}));